import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const Calculator = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M25.6 0a3.2 3.2 0 0 1 3.2 3.2v25.6a3.2 3.2 0 0 1-3.2 3.2H6.4a3.2 3.2 0 0 1-3.2-3.2V3.2A3.2 3.2 0 0 1 6.4 0h19.2zm-7.467 24.533h-4.267V28.8h4.267v-4.267zm7.467 0h-4.267V28.8H25.6v-4.267zm-14.933 0H6.4V28.8h4.267v-4.267zm0-7.466H6.4v4.267h4.267v-4.267zm7.466 0h-4.267v4.267h4.267v-4.267zm7.467 0h-4.267v4.267H25.6v-4.267zm0-13.867H6.4v9.6h19.2V3.2z" />
    </SvgIcon>
  );
});

Calculator.displayName = "Calculator";

export default Calculator;
